import type { ReactNode } from 'react';

/**
 * Render `text` with fuzzy-matched character positions marked (the visual half
 * of `fuzzyRank`, src/lib/fuzzy.ts). Consecutive hits render as one `<mark>`
 * run. Shared by the quick switcher, the entity picker, and the pin-to-view
 * picker - one implementation, styling stays the consumer's (`markClassName`).
 */
export function Highlight({
  text,
  positions,
  markClassName,
}: {
  text: string;
  positions: number[];
  markClassName?: string;
}) {
  if (positions.length === 0) return <>{text}</>;
  const hit = new Set(positions);
  const parts: ReactNode[] = [];
  let run = '';
  let runHit = hit.has(0);
  const flush = (i: number) => {
    if (run === '') return;
    parts.push(
      runHit ? (
        <mark key={i} className={markClassName}>
          {run}
        </mark>
      ) : (
        run
      ),
    );
    run = '';
  };
  for (let i = 0; i < text.length; i++) {
    const h = hit.has(i);
    if (h !== runHit) {
      flush(i);
      runHit = h;
    }
    run += text[i];
  }
  flush(text.length);
  return <>{parts}</>;
}
